<!-- <div class="modal-header" style="background:#f5f5f5">
    <h6 class="modal-title pull-left" style="color:#000000">
        <i class="fa fa-files-o"></i> Sua opinião é importante para nós!
    </h6>
    <button type="button" (click)="close()" class="close pull-right" data-dismiss="modal" aria-label="Close"
        style="color:#000000">
        <span aria-hidden="true">&times;</span>
    </button>
</div> -->

<div class="modal-body">

    <div class="row">
        <div class="col-xl-12">
            <div style="text-align: center;">
                <img src="assets/imagens/email.svg" alt="pesquisa" />
            </div>
            <div>
                <p class="text-justify" style="margin-top: 15px;">Gostaríamos de saber o que você tem achado do nosso
                    site. Sua opinião é muito importante para nós!
                </p>
                <p class="text-justify" style="margin-top: 8px;">Clique no botão <b>"Responder"</b> abaixo para avaliar sua
                    experiência, leva menos de 1 minuto!</p>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <div class="text-left" style="float:left">
        <button type="button" class="btn btn-outline-danger btn-sm" (click)="close()">
            Agora não
        </button>
    </div>
    <div class="text-right" style="float:right">
        <button type="button" class="btn btn-success btn-sm" (click)="responder()">Responder</button>
    </div>
</div>